import type { ReminderItem } from '@nexus/core';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../api/client';
import type { SessionInfo } from '../api/types';
import { useModules } from '../modules/context';
import type { WebModule } from '../modules/define';
import { canIn, useSession } from '../session/session';

export const myRemindersQuery = queryOptions({
  queryKey: ['reminders', 'mine'],
  queryFn: ({ signal }) =>
    api.get<{ items: ReminderItem[]; more: boolean }>('/reminders/mine', { signal }),
});

export function recordRemindersQuery(entity: string, recordId: string) {
  return queryOptions({
    queryKey: ['reminders', entity, recordId],
    queryFn: ({ signal }) =>
      api.get<ReminderItem[]>(
        `/reminders?${new URLSearchParams({ entity, recordId }).toString()}`,
        {
          signal,
        },
      ),
  });
}

/** Whether some active module lets the person set reminders: shows "Für mich". */
export function canRemindIn(modules: readonly WebModule[], session: SessionInfo): boolean {
  return modules
    .filter((m) => session.modules.includes(m.manifest.id))
    .some((m) =>
      (m.manifest.activity ?? []).some(
        (a) => a.remind !== undefined && canIn(session, a.remind) && canIn(session, a.read),
      ),
    );
}

export function useCanRemind(): boolean {
  return canRemindIn(useModules(), useSession());
}

/** Noon of the day, so time zones never move it to the day before. */
export function dueDate(dueOn: string): Date {
  return new Date(`${dueOn}T12:00:00`);
}
